import React, { useEffect, useState } from "react";
import styles from "./ActionButtons.module.scss";
import { useSwiperSlide } from "swiper/react";

type ButtonProps = {
  activeIndex: number;
  swiper: any;
};

export const NextButton: React.FC<ButtonProps> = ({ activeIndex, swiper }) => {
  return (
    <>
      {swiper.slides.length && (
        <button
          className={`${styles.NextButton}`}
          onClick={() => swiper.slideNext()}
        ></button>
      )}
    </>
  );
};
export const PrevButton: React.FC<ButtonProps> = ({ activeIndex, swiper }) => {
  return (
    <>
      {swiper.slides.length && (
        <button
          className={`${styles.PrevButton}
          `}
          onClick={() => swiper.slidePrev()}
        ></button>
      )}
    </>
  );
};

export const ActionButtons: React.FC<ButtonProps> = (props) => {
  const { activeIndex, swiper } = props;
  const swiperSlide = useSwiperSlide();
  const [activeButtons, setActiveButtons] = useState(false);

  useEffect(() => {
    if (swiperSlide.isActive) {
      setTimeout(() => {
        setActiveButtons(true);
      }, 200);
    } else {
      setActiveButtons(false);
    }
  }, [swiperSlide]);

  return (
    <>
      {Object.keys(swiper).includes("slides") && activeButtons && (
        <>
          <PrevButton activeIndex={activeIndex} swiper={swiper}></PrevButton>{" "}
          <NextButton activeIndex={activeIndex} swiper={swiper}></NextButton>
        </>
      )}
    </>
  );
};
